// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
// import axios from 'axios';
import {AXIOS} from './core/http-commons';
import Vue from 'vue';
import App from './App';
import router from './router';
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  transitions,
  VDivider,
  VJumbotron,
  VCard,
  VTextField,
  VDialog,
  VTooltip,
  VSelect,
  VDataTable,
  VProgressLinear,
  VSnackbar,
  VAlert,
  VMenu,
  VDatePicker,
  VTimePicker,
  VSubheader,
  VBtnToggle,
  VForm,
  VProgressCircular,
  VSwitch,
  VChip,
  VExpansionPanel,
  VDataIterator,
  VCombobox,
  VTextarea,
  VAvatar
} from 'vuetify';
import Form from './core/Form';
import { store } from "./store/store";
import '../node_modules/vuetify/src/stylus/app.styl';

window.axios = AXIOS;
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const token = localStorage.getItem('token');
if (token) {
  window.axios.defaults.headers.common['Authorization'] = token
}

window.Form = Form;

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    transitions,
    VDivider,
    VJumbotron,
    VCard,
    VTextField,
    VDialog,
    VTooltip,
    VSelect,
    VDataTable,
    VProgressLinear,
    VSnackbar,
    VAlert,
    VMenu,
    VDatePicker,
    VTimePicker,
    VSubheader,
    VBtnToggle,
    VForm,
    VProgressCircular,
    VSwitch,
    VChip,
    VExpansionPanel,
    VDataIterator,
    VCombobox,
    VTextarea,
    VAvatar
  }
});

// Register custom components to use in HTML template
import DefaultLayout from './appLayouts/Default';
import NoSidebarLayout from './appLayouts/NoSidebar';
import LoginLayout from "./appLayouts/LoginLayout";
import CSlots from './components/resources/Slots';
import CFloorPlanDesigner from './components/layout/FloorPlanDesigner';
import CSeat from './components/layout/Seat';
import CScreen from './components/layout/Screen';
import CUIText from './components/layout/UIText';
import CWall from './components/layout/Wall';
import CRailing from './components/layout/Railing';
import CLegend from './components/booking/Legend';
import CBusinessRules from './components/settings/BusinessRules';
Vue.component('default-layout', DefaultLayout);
Vue.component('no-sidebar-layout', NoSidebarLayout);
Vue.component('login-layout', LoginLayout);
Vue.component('c-slots', CSlots);
Vue.component('c-floor-plan-designer', CFloorPlanDesigner);
Vue.component('c-seat', CSeat);
Vue.component('c-screen', CScreen);
Vue.component('c-ui-text', CUIText);
Vue.component('c-wall', CWall);
Vue.component('c-railing', CRailing);
Vue.component('c-legend', CLegend);
Vue.component('c-business-rules', CBusinessRules);

Vue.config.productionTip = false;

Vue.mixin({
  data: () => ({
    SLOT_CATEGORY_REGULAR: 1,
    SLOT_CATEGORY_VIP: 2,
    SLOT_CATEGORY_WHEELCHAIR: 3,
    SLOT_CATEGORY_RECLINER: 4,
    SLOT_CATEGORY_COMPANION: 5,
    DEFAULT_CANVAS_ZOOM: 100,
    MAX_CANVAS_ZOOM: 200,
    MIN_CANVAS_ZOOM: 50
  }),

  methods: {
    /* returns a benchmark for a specific channel code */
    getBenchmarkByChannelCode(ruleBenchmarks, channelCode) {
      for (let i = 0; i < ruleBenchmarks.length; i++) {
        let ruleBenchmark = ruleBenchmarks[i];
        if (ruleBenchmark.channel.code === channelCode){
          return ruleBenchmark.benchmark;
        }
      }
      return null;
    }
  }
});

/* eslint-disable no-new */
new Vue({
  store: store,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js